export const PAGE_KEY = 'page';
export const PAGE_SIZE = 10;
export const TOTAL_PAGES_KEY = 'totalPages';
export const PAGE_ITEMS_KEY = 'items';
export const TOTAL_ITEMS_KEY = 'totalItems';

export default {
  PAGE_KEY,
  PAGE_SIZE,
  TOTAL_PAGES_KEY,
  PAGE_ITEMS_KEY,
  TOTAL_ITEMS_KEY,
};
